export const delayTime = 1000;
export const minChars = 3;
export const minLength = 0;
